import {EventEmitter, Injectable} from "@angular/core";
import {ModalInstance} from "./ModalInstance";

@Injectable({providedIn: "root"})
export class ModalEventsService {

  /**
   * Global hook for opening modals
   */
  openModalEvents = new EventEmitter<ModalInstance<any>>();

}
